import React, { useState,useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";

import { addThousandPoint,GetSimpleYearMonth } from "../../components/common/Common";
import "../../css/style.css";

const TextBookDetail = () => {
  let { tb_idx } = useParams();

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varBookOrderInfo,setBookOrderInfo] = useState({});
  const [varBookOrderList,setBookOrderList] = useState([]);

  //교재 주문 정보 호출
  const GetBookOrderInformation = async() => {
    const sendData  = {tb_idx:tb_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_textbook_orders`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        //교재주문정보
        setBookOrderInfo(datas.orders[0]);
        //교재세부주문정보
        setBookOrderList(datas.orderList);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    //교재 주문 정보 호출
    GetBookOrderInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={'교재 확인 상세'}/>
      <div className="vh-content-body">
        <div className="textbook-view-wrap">
          <div className="center-wrap">
            <div className="view-tit">{GetSimpleYearMonth(varBookOrderInfo.tb_rdate,'.')}월 교재 확인 내역서</div>
            <table id="">
              <thead>
								<tr><th>과목</th><th>단계</th><th>수량</th><th>가격</th><th>계</th></tr>
							</thead>
              <tbody>
                {varBookOrderList.map((orders,i)=>(
                  <tr key={'orders_'+i}>
                    <td>{orders.vb_vt_mode===1?"수/연산":"감각/기하"}</td>
                    <td>{orders.vb_vt_name}</td>
                    <td>{orders.tbl_number}</td>
                    <td>{addThousandPoint(orders.tbl_price)}</td>
                    <td>{addThousandPoint(orders.tbl_price * orders.tbl_number)}</td>
                  </tr>
                ))}
                <tr>
									<td colSpan="2">합계</td>
									<td>{addThousandPoint(varBookOrderInfo.tb_number)}</td>
									<td colSpan="2">{addThousandPoint(varBookOrderInfo.tb_amount)}</td>
								</tr>
              </tbody>
            </table>
            <div className="account-wrap">
							<p className="tit">입금 계좌 안내</p>
							<div className="line">
								<p>은행</p>
								<div>신한은행</div>
							</div>
							<div className="line">
								<p>계좌번호</p>
								<div>123-456-12345</div>
							</div>
							<div className="line">
								<p>예금주</p>
								<div>마마몽떼</div>
							</div>
							<div className="line">
								<p>정산관련 문의</p>
								<div>02-1234-1234</div>
							</div>
						</div>
          </div>
        </div>
      </div>
    </div>	
  )
}
export default TextBookDetail;